import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import lang from './lang'
import app from './app'
import reviewPageDetail from './reviewPageDetail'
import pageApiHeaders from './pageApiHeaders'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  strict: true, // 严格模式
  devtools: debug, // 开发模式下使用devtools
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    lang,
    app,
    reviewPageDetail,
    pageApiHeaders
  },
  getters: {
    user: state => state.user,
    lang: state => state.lang,
    app: state => state.app,
    reviewPageDetail: state => state.reviewPageDetail,
    pageApiHeaders: state => state.pageApiHeaders,
  }
})
export default store